import { render } from "./comment-answer.vue?vue&type=template&id=49c3e646&ts=true"
import script from "./comment-answer.vue?vue&type=script&lang=ts"
export * from "./comment-answer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__